import styled from 'styled-components';
import { NAVBAR_HEIGHT } from '../../utils/constants';
import { colors } from '../../utils/designTokens';

export const PageContainer = styled.div`
    padding-top: 4rem; /* Mobile navbar height */
    overflow-x: hidden;
    width: 100%;
    max-width: 100vw;

    @media (min-width: 768px) {
        padding-top: ${NAVBAR_HEIGHT}; /* Desktop navbar height */
    }
`;

export const Background = styled.div`
    position: relative;
    min-height: 50vh;
    padding-top: 4rem;
    padding-bottom: 3rem;
    overflow: hidden;

    /* Enhanced Gradient Background */
    &::before {
        content: '';
        position: absolute;
        inset: 0;
        background: radial-gradient(
            ellipse 120% 80% at 50% -20%,
            #f3e8ff 0%,
            #fce7f3 35%,
            #ffffff 70%
        );
        opacity: 0.8;
        z-index: 0;
    }

    /* Backdrop blur layer */
    &::after {
        content: '';
        position: absolute;
        inset: 0;
        background: rgba(255, 255, 255, 0.3);
        backdrop-filter: blur(2px);
        z-index: 0;
    }

    @media (min-width: 768px) {
        min-height: 60vh;
        padding-top: 12rem;
        padding-bottom: 8rem;
    }
`;

export const SearchBarContainer = styled.div`
    position: relative;
    z-index: 100;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    max-width: 1280px;
    width: 100%;
    margin: 0 auto;
    padding: 0 1rem;
    box-sizing: border-box;
`;

export const CardGalleryContainer = styled.div`
    display: flex;
    justify-content: center;
`;

export const TitleMain = styled.h1`
    font-size: 2rem;
    font-weight: 800;
    color: ${colors.black};
    margin: 0 0 1rem 0;
    letter-spacing: -0.025em;
    line-height: 1.1;
    padding: 0 0.5rem;

    @media (min-width: 480px) {
        font-size: 2.5rem;
    }

    @media (min-width: 768px) {
        font-size: 4.5rem;
        margin: 0 0 1.5rem 0;
        padding: 0;
    }
`;

export const Subtitle = styled.p`
    font-size: 0.9375rem;
    color: ${colors.gray500};
    max-width: 42rem;
    margin: 0 auto 1.5rem auto;
    line-height: 1.6;
    padding: 0 1rem;

    @media (min-width: 768px) {
        font-size: 1.25rem;
        margin: 0 auto 2.5rem auto;
        line-height: 1.75;
        padding: 0;
    }
`;

export const StatText = styled.p`
    font-size: 0.8125rem;
    font-weight: 600;
    color: ${colors.gray500};
    margin-top: 1.5rem;

    span {
        color: ${colors.black};
        font-weight: 700;
    }

    @media (min-width: 768px) {
        font-size: 0.875rem;
        margin-top: 3rem;
    }
`;

export const Overlay = styled.div`

`;

interface SectionWrapperProps {
    backgroundColor?: string;
}

export const SectionWrapper = styled.div<SectionWrapperProps>`
    background-color: ${props => props.backgroundColor || 'white'};
    padding: 4rem 0;

    @media (min-width: 768px) {
        padding: 5rem 0;
    }
`;

export const SectionContent = styled.div`
    max-width: 1280px;
    margin: 0 auto;
    padding: 0 1rem;

    @media (min-width: 640px) {
        padding: 0 1.5rem;
    }

    @media (min-width: 1024px) {
        padding: 0 2rem;
    }
`;

export const SectionTitle = styled.h2`
    font-size: 1.5rem;
    font-weight: 700;
    color: ${colors.gray900};
    margin-bottom: 2rem;

    @media (min-width: 768px) {
        font-size: 1.875rem;
    }
`;

export const HorizontalScroll = styled.div`
    display: flex;
    overflow-x: auto;
    padding-bottom: 2rem;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;

    /* Hide scrollbar */
    scrollbar-width: none;
    -ms-overflow-style: none;
    &::-webkit-scrollbar {
        display: none;
    }
`;
